import { AxiosError } from 'axios';

import { createAsyncThunk } from '@reduxjs/toolkit';

import { deviceProfilesApi } from '@/api/index';

export const fetchDeviceProfiles = createAsyncThunk(
  'deviceProfiles',
  async (params, thunkAPI) => {
    try {
      const response = await deviceProfilesApi.getAll();
      return response ? response.data : [];
    } catch (e) {
      if (e instanceof AxiosError) {
        return thunkAPI.rejectWithValue(e.message);
      }
      throw e;
    }
  },
);
